import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { PageNotFoundSvg } from '../../assets/images';
import { SITE_LINKS } from '../../constants';
import { Background } from '../../stories/Background';
import { Button } from '../../stories/Button';
import { Header } from '../../stories/Header';
import { Link } from '../../stories/Link';

interface NotFoundPageProps {
  data?: {
    errorCode?: string;
  };
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({ data }) => {
  const __ = useTranslation().t;

  return (
    <>
      <Header type="logo-only" />
      <Background>
        <div className="oejr-utility-page">
          <Container>
            <Row className="justify-content-center align-items-center">
              <Col sm={12} md={6} className="text-center">
                <PageNotFoundSvg />
              </Col>
              <Col sm={12} md={6}>
                <div className="oejr-utility-page-text-container">
                  <h1 className="oejr-utility-page-header">{__('sorryPageNotFoundMessage')}</h1>
                  <p className="oejr-utility-page-description">{__('pageNoLongerExistsMessage')}</p>

                  <div className="oejr-utility-page-links-container">
                    <p>
                      <Link italic={false} variant="orange-main" href={SITE_LINKS.HomePage}>
                        {__('course')}
                      </Link>
                    </p>
                    <p>
                      <Link
                        italic={false}
                        variant="orange-main"
                        href={SITE_LINKS.LiveClassHistoryPage}
                      >
                        {__('progress')}
                      </Link>
                    </p>
                    <p>
                      <Link italic={false} variant="orange-main" href={SITE_LINKS.HelpPage}>
                        {__('help')}
                      </Link>
                    </p>
                    <p>
                      <Link italic={false} variant="orange-main" href={SITE_LINKS.ProfilePage}>
                        {__('profile')}
                      </Link>
                    </p>
                  </div>

                  <p className="oejr-utility-page-error-code">
                    {__('errorCode', { errorCode: data?.errorCode ?? '404' })}
                  </p>
                </div>

                <Button label={__('goBack')} onClick={() => window.history.back()} />
              </Col>
            </Row>
          </Container>
        </div>
      </Background>
    </>
  );
};
